export type PageType =
  | 'GetStarted'
  | 'CollectGender'
  | 'CollectGoals'
  | 'CollectMotivations'
  | 'CollectFitnessLevel'
  | 'CollectRunningHistory'
  | 'CollectWalkingTime'
  | 'CollectEndurance'
  | 'CollectPersonalBest'
  | 'CollectMusic'
  | 'Results'
  | 'BuildingProfile'
  | 'SendToApp';

export const pathForPage = (page: PageType): string => {
  switch (page) {
    case 'GetStarted':
      return '/start';
    case 'CollectGender':
      return '/gender';
    case 'CollectGoals':
      return '/goals';
    case 'CollectMotivations':
      return '/motivations';
    case 'CollectFitnessLevel':
      return '/fitness-level';
    case 'CollectRunningHistory':
      return '/running-history';
    case 'CollectWalkingTime':
      return '/walking-time';
    case 'CollectEndurance':
      return '/endurance';
    case 'CollectPersonalBest':
      return '/personal-best';
    case 'CollectMusic':
      return '/music';
    case 'Results':
      return '/results';
    case 'BuildingProfile':
      return '/building-profile';
    case 'SendToApp':
      return '/sync';
    default:
      return '/';
  }
};
